<template>
  <div class="relative">
    <Resource
      v-if="cover"
      :src="cover"
      class="w-full h-full object-cover rounded-[12px] overflow-hidden"
      fetchpriority="hightest"
      :transform-resource="transformImage"
    />
    <div class="absolute top-[56%] -translate-y-1/2 left-[50px] z-30" :class="contentClass">
      <h1 class="m-0 pl-5 banner-title text-[var(--purple-10)]">
        {{ title }}
      </h1>
      <Search
        v-if="showSearch"
        v-model="_keyword"
        type="default"
        class="mx-auto mt-[12px] banner-search-input"
        :placeholder="placeholder || $t('sou-suo')"
        :showRecommend="showRecommend"
        :showHot="true"
        :area="area"
        @search="handleOnSearch"
      >
      </Search>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Search from '@/features/searchInput/index.vue';
import { SEARCH_RECORD_UNIQUE } from '~/constants';
import { transformImage } from '~/utils';

interface BannerProps {
  title: string;
  cover: string;
  showSearch?: boolean;
  area: SEARCH_RECORD_UNIQUE;
  placeholder?: string;
  contentClass?: string;
  showRecommend?: boolean;
}

withDefaults(defineProps<BannerProps>(), {
  showSearch: true,
});
const emit = defineEmits(['search']);

const _keyword = defineModel<string>('keyword');

const handleOnSearch = (val: string) => {
  emit('search', val);
};
</script>
<style lang="scss" scoped>
.banner-search-input {
  width: 520px;
  :deep(.ant-input-affix-wrapper) {
    border-radius: 20px !important;
  }

  :deep(.ant-input-affix-wrapper-lg) {
    padding-top: 7.3px;
    padding-bottom: 7.3px;
  }
}

.banner-title {
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
}
</style>
